import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/asana_logo.png'


const _hoisted_1 = { class: "asana-popup-wrapper" }
const _hoisted_2 = { class: "Asana-popup-block" }
const _hoisted_3 = { class: "h5" }
const _hoisted_4 = { class: "button-text-one" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "Asana-logo",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "button-text-two" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_box = _resolveComponent("check-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("component-asana-popup.get-best")), 1),
      _createElementVNode("div", {
        class: "Asana-button h5",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connectAsana && _ctx.connectAsana(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("component-asana-popup.link-your")), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("component-asana-popup.account")), 1)
      ]),
      _createVNode(_component_check_box, {
        class: "asana-popup-checkbox",
        checkboxText: _ctx.checkboxText,
        checkActive: _ctx.checkboxMarked,
        size: 'default',
        onToggleCheckBox: _ctx.toggleCheckBox
      }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"]),
      _createElementVNode("div", {
        class: "skip-button medium-text",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.skipPopup && _ctx.skipPopup(...args)))
      }, _toDisplayString(_ctx.$t("component-asana-popup.skip")), 1)
    ])
  ]))
}